import ContentLoader from 'react-content-loader';

import { useSkeletonColors } from 'hooks';

function SingleLoader() {
  const skeletonColors = useSkeletonColors();

  return (
    <ContentLoader
      speed={2}
      {...skeletonColors}
      height="102px"
    >
      <rect x="0" y="0" rx="3" ry="3" width="100%" height="102px" />
    </ContentLoader>
  );
}

export default function InvoicesLoader() {
  return (
    <div style={{ display: 'flex', gap: '1rem', flexDirection: 'column' }}>
      <SingleLoader />
      <SingleLoader />
    </div>
  );
}
